module.exports = __webpack_public_path__ + "img/productionBase_14.f6614b1e.png";